import { FormikValues, useFormikContext } from 'formik';
import {
  AdminEssayQuestions,
  AdminMarkWordQuestions,
  AdminFlashcardsQuestions,
  AdminDragDropQuestions,
  AdminCrosswordQuestions,
  AdminFindWordQuestions,
  AdminTimeline,
  AdminTrueFalseQuestions,
  AdminDragWordQuestions,
  AdminQuizQuestions,
  AdminQuizDragDropQuestions,
  AdminAssessmentQuestions,
} from './activity';
import { ActivityImage } from './activity-image';

export interface AdminActivity<T extends AdminActivityType = AdminActivityType> {
  id?: string;
  type: AdminActivityType;
  attemptsNum: number;
  questions: Required<AdminActivitiesForm>[T]['questions'];
  image?: ActivityImage[];
}

export type AdminActivityApi<T extends AdminActivityType> = Partial<
  Required<AdminActivitiesForm>[T]['questions']
> & {
  id?: string;
  attemptsNum: number;
  type: AdminActivityType;
};

export type AdminActivityType = keyof AdminActivitiesForm;

export interface AdminActivitiesForm {
  essay?: AdminEssayQuestions;
  markWord?: AdminMarkWordQuestions;
  flashcards?: AdminFlashcardsQuestions;
  dragDrop?: AdminDragDropQuestions;
  crossword?: AdminCrosswordQuestions;
  findWord?: AdminFindWordQuestions;
  timeline?: AdminTimeline;
  trueFalse?: AdminTrueFalseQuestions;
  dragWord?: AdminDragWordQuestions;
  quiz?: AdminQuizQuestions;
  quizDragDrop?: AdminQuizDragDropQuestions;
  assessment?: AdminAssessmentQuestions;
}

export type AdminActivitiesFormikType = FormikInstance<AdminActivitiesForm>;

export type FormikInstance<T extends FormikValues = FormikValues> = ReturnType<
  typeof useFormikContext<T>
>;

export const ACTIVITY_TYPE_OPTIONS = [
  { label: 'Assessment', value: 'assessment' },
  { label: 'Drag and drop', value: 'dragDrop' },
  { label: 'Essay', value: 'essay' },
  { label: 'Crassword', value: 'crossword' },
  { label: 'Find the words', value: 'findWord' },
  { label: 'Flashcards', value: 'flashcards' },
  { label: 'Timeline', value: 'timeline' },
  { label: 'True or False', value: 'trueFalse' },
  { label: 'Mark the word', value: 'markWord' },
  { label: 'Drag the word', value: 'dragWord' },
  { label: 'Quiz drag and drop', value: 'quizDragDrop' },
  { label: 'Quiz', value: 'quiz' },
] as const;

export const EMPTY_QUESTION: AdminQuizQuestions['questions']['questions'][number] = {
  question: '',
  answers: [
    {
      value: '',
      isTrue: 'false',
    },
    {
      value: '',
      isTrue: 'false',
    },
    {
      value: '',
      isTrue: 'false',
    },
    {
      value: '',
      isTrue: 'false',
    },
  ],
};

export type ActivityTypeSelectOptions =
  (typeof ACTIVITY_TYPE_OPTIONS)[number] & {
    disabled?: boolean;
  };

export const ACTIVITY_ATTEMPTS_OPTIONS = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
] as const;

export type ActivityAttemptsSelectOptions =
  (typeof ACTIVITY_ATTEMPTS_OPTIONS)[number];

export const TRUE_FALSE_OPTIONS = [
  { name: 'True', value: 'true' },
  { name: 'False', value: 'false' },
] as const;

